export { AdultosCardDetails } from "./AdultosCardDetails";
